<template>
    <div class="wrapper blog_mod">
        <div class="base blog_mod">
            <section>
                <div class="section_in terms">
                    <div class="offset-top-30">
                        <p class="text-bold text-center terms_subtitle">
                            ŚWIADCZENIA USŁUG DROGĄ ELEKTRONICZNĄ POPRZEZ
                        </p>
                        <p class="text-bold text-center terms_subtitle">
                            PLATFORMĘ EDUKACYJNĄ NOVAKID.PL
                        </p>
                    </div>
                    <div class="offset-top-40">
                        <h6 class="terms_list_title text-bold text-center">
                            §1
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            SŁOWNICZEK
                        </h6>
                    </div>
                    <div class="offset-top-60">
                        <p class="terms_list_item">
                            1. <strong>Novakid</strong>
                            – usługodawca, którym jest podmiot prowadzący
                            działalność gospodarczą na podstawie przepisów prawa
                            Stanów Zjednoczonych: Novakid Inc USA, 548 Market St
                            8291, San Francisco, CA 94104-5401.
                        </p>
                        <p class="terms_list_item">
                            2. <strong>Użytkownik</strong>
                            – osoba fizyczna posiadającą zdolność do czynności
                            prawnych, która za pośrednictwem Strony i Platformy,
                            w oparciu o Regulamin, zawiera z Novakid umowę o
                            świadczenie usług.
                        </p>
                        <p class="terms_list_item">
                            3. <strong>Administratorzy</strong>
                            - osoby upoważnione i działające w imieniu Novakid,
                            zajmujące się koordynacją świadczenia Usług i
                            czynnościami dotyczącymi wykonywania Umowy.
                        </p>
                        <p class="terms_list_item">
                            4. <strong>Dziecko</strong>
                            - osoba fizyczna poniżej 18. roku życia, której za
                            zgodą opiekuna prawnego został umożliwiony dostęp do
                            korzystania z Platformy w celu uczestniczenia w
                            lekcjach językowych.
                        </p>
                        <p class="terms_list_item">
                            5. <strong>Konto</strong>
                            – indywidualne, elektroniczne konto, nadane
                            konkretnemu Użytkownikowi, umożliwiające korzystanie
                            z platformy służącej do nauki języków obcych.
                        </p>
                        <p class="terms_list_item">
                            6. <strong>Platforma</strong>
                            – edukacyjna strona internetowa, za pomocą której
                            Novakid świadczy Usługę, dostępna dla Użytkowników,
                            którzy mają założone Konto, utrzymywana na portalu
                            internetowym działającym pod adresem www.novakid.pl
                            wraz z subdomenami.
                        </p>
                        <p class="terms_list_item">
                            7. <strong>Strona</strong>
                            – strona internetowa, za pomocą której Novakid
                            świadczy Usługę, dostępna dla Użytkowników, którzy
                            mają założone Konto, utrzymywana na portalu
                            internetowym działającym pod adresem www.novakid.pl
                            wraz z subdomenami.
                        </p>
                        <p class="terms_list_item">
                            8. <strong>Lektor</strong>
                            – osoba fizyczna prowadząca lekcje za pośrednictwem
                            Platformy dla Dzieci w ramach usług świadczonych
                            przez Novakid.
                        </p>
                        <p class="terms_list_item">
                            9. <strong>Rejestracja</strong>
                            – czynność polegająca na założeniu przez Użytkownika
                            Konta.
                        </p>
                        <p class="terms_list_item">
                            10. <strong>Dane dostępowe</strong>
                            - login wraz z hasłem umożliwiające zalogowanie się
                            do Platformy.
                        </p>
                        <p class="terms_list_item">
                            11. <strong>Treści</strong>
                            - dane tekstowe, dane graficzne, pliki audio (np.
                            nagrania), pliki audio/wideo (np. wideoklipy, filmy,
                            obiekty multimedialne, nagrania o Lektorach, kursy,
                            itd.).
                        </p>
                        <p class="terms_list_item">
                            12. <strong>Umowa</strong>
                            – umowa o świadczenie Usług zawarta pomiędzy Novakid
                            a Użytkownikiem na czas nieokreślony , zawierana na
                            odległość.
                        </p>
                        <p class="terms_list_item">
                            13. <strong>Usługa</strong>
                            – prowadzenie lekcji językowych dla Dzieci za
                            pośrednictwem Platformy, płatnych oraz bezpłatnych,
                            w sposób umożliwiający bezpośrednią komunikację
                            Użytkownika i Dziecka z Lektorem oraz transmisję
                            obrazu, w tym obejmującą wizerunek Użytkownika,
                            Dziecka i Lektora.
                        </p>
                        <p class="terms_list_item">
                            14. <strong>Pakiet lekcji</strong>
                            – umowa zawarta na czas nieokreślony, w ramach
                            której Novakid zobowiązuje się za określoną cenę do
                            świadczenia Usług poprzez przeprowadzenie z góry
                            ustalonej liczby lekcji dostępnej do zakupu przez
                            Użytkowników poprzez Konto. Szczegółowe warunki
                            zakupu każdego Pakietu usług lekcji dostępne są na
                            profilu Konta.
                        </p>
                        <p class="terms_list_item">
                            15. <strong>Ubskrypcja lub Abonament</strong>
                            – umowa zawarta na czas nieokreślony, w ramach
                            której Novakid zobowiązuje się za określoną cenę do
                            przeprowadzenia oznaczonej liczby lekcji w tygodniu,
                            świadczona ciągle w ramach okresu subskrypcji,
                            dostępna do zakupu przez Użytkowników poprzez Konto.
                            Szczegółowe warunki zakupu Subskrypcji, w
                            szczególności jej rodzaje, dostępne są na profilu
                            Konta. W ramach subskrypcji Novakid jest uprawniony
                            do regularnego, następującego co 28 dni, pobierania
                            z karty Użytkownika ceny abonamentu, a lekcje w
                            subskrypcji są ważne tylko w ramach bieżącego Okresu
                            subskrypcj
                        </p>
                        <p class="terms_list_item">
                            16. <strong>Okres subskrypcji</strong>
                            – czas ważności Subskrypcji liczony od daty jej
                            aktywacji lub kolejnego przedłużenia jako 28 dni
                            kalendarzowych, okres może być zmieniony (skrócony),
                            jeśli ilość ustalonych przez Użytkownika lekcji
                            przypadających na dany okres subskrypcji
                            przekroczyła liczbę lekcji nią objętych. W przypadku
                            długiej subskrypcji (12 tygodni lub 24 tygodnie), 1
                            subskrypcja obejmuje 3 lub 6 podstawowych Okresów
                            subskrypcji w zależności od wybranej długości.
                        </p>
                        <p class="terms_list_item">
                            17. <strong>Saldo lekcji</strong>
                            – informacja o ilości lekcji, które pozostały do
                            wykorzystania przez Użytkownika z przysługującego mu
                            Pakietu lekcji, widniejąca na jego Koncie. Saldo
                            lekcji nie jest dostępne na Koncie Użytkownika,
                            który wykupił Subskrypcję.
                        </p>
                        <p class="terms_list_item">
                            18. <strong>Bilans bonusowy</strong>
                            – informacja o liczbie bonusów, z których Użytkownik
                            może skorzystać przy zapłacie za usługi na rzecz
                            Novakid, a które zostają przyznane w ramach
                            promocji, reklamacji, zmiany rodzaju Usług oraz
                            rekompensat za lekcje, które przepadły.
                        </p>
                        <p class="terms_list_item">
                            19. <strong>Bonusy i promocje</strong>
                            - czynności, wykonywane przez Administratorów,
                            skierowane na realizację Usług poprzez podanie kodu
                            (promo kodu) lub zaksięgowanie sumy na bilansie
                            bonusowym, aby zachęcić i/lub zmotywować Użytkownika
                            do świadczenia usług.
                        </p>
                        <p class="terms_list_item">
                            20.
                            <strong>Gotowość do uczestnictwa w lekcji</strong>
                            - sytuacja, w której Użytkownik lub Lektor jest
                            zalogowany na swoim Koncie w Platformie w dacie i
                            godzinie właściwej dla planowanej, zgodnie z
                            harmonogramem, lekcji i celem rozpoczęcia lekcji
                            wybrał opcję „Wejdź do klasy”.
                        </p>
                        <p class="terms_list_item">
                            21. <strong>Harmonogram </strong>
                            - ustalony przez Novakid i Użytkownika plan
                            świadczenia Usługi, obejmujący daty i godziny lekcji
                            Dziecka z Lektorem.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §2
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            2. POSTANOWIENIA OGÓLNE
                        </h6>
                        <p class="terms_list_item">
                            1. Niniejszy dokument (zwany dalej „Regulaminem”)
                            określa ogólne warunki korzystania z Platformy oraz
                            prawa i obowiązki stron Umowy w związku ze
                            świadczeniem usług drogą elektroniczną, a także
                            zawieraniem ww. Umowy na odległość.
                        </p>
                        <p class="terms_list_item">
                            2. Przed rozpoczęciem korzystania z Platformy oraz
                            Usług koniecznym jest zapoznanie się z niniejszym
                            Regulaminem, a także zaakceptowanie jego treści.
                        </p>
                        <p class="terms_list_item">
                            3. Novakid udostępnia niniejszy Regulamin na Stronie
                            w sposób umożliwiający zapoznanie się z jego treścią
                            w każdym czasie, a także swobodne kopiowanie,
                            drukowanie, pobieranie.
                        </p>
                        <p class="terms_list_item">
                            4. Użytkownik zobowiązuje się do przestrzegania
                            zasad określonych niniejszym Regulaminem.
                        </p>
                        <p class="terms_list_item">
                            5. Kontakt z obsługą administracyjną lub techniczną
                            Novakid jest możliwy od poniedziałku do niedzieli w
                            godzinach od 09.00 do 20.30 CEST:
                        </p>
                        <ul>
                            <li>poprez czat Novakid.pl</li>
                            <li>
                                poprzez wiadomość e-mail na adres:
                                bok@novakid.pl, który jest właściwy do
                                kierowania wszelkiej korespondencji do Novakid
                            </li>
                        </ul>
                        <p class="terms_list_item">
                            Aktualne informacje obejmujące dane kontaktowe i
                            godziny pracy dostępne są pod adresem:
                            www.novakid.pl
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §3
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            REJESTRACJA
                        </h6>
                        <p class="terms_list_item">
                            1. Założenie Konta na Platformie jest bezpłatne.
                        </p>
                        <p class="terms_list_item">
                            2. Użytkownik może posiadać wyłącznie jedno Konto z
                            indywidualnie do niego przyporządkowanym adresem
                            e-mail i numerem telefonu.
                        </p>
                        <p class="terms_list_item">
                            3. Celem założenia Konta Użytkownik wypełnia
                            formularz rejestracyjny znajdujący się na Stronie. W
                            tym celu konieczne jest podanie następujących
                            danych: imienia, adresu e-mail, numeru telefonu, a
                            następnie wybór opcji „umów lekcję próbną”.
                            Następnie celem umówienia daty i godziny pierwszej
                            bezpłatnej lekcji Użytkownik jest zobowiązany do
                            podania danych w postaci imienia oraz wieku dziecka.
                            Następnie Novakid kontaktuje się z Użytkownikiem: na
                            podany przez Użytkownika adres e-mail oraz numer
                            telefonu wysyłane są dane dostępowe i instrukcje.
                        </p>
                        <p class="terms_list_item">
                            4. Użytkownik akceptuje konieczność posiadania
                            aktualnego, czynnego adresu poczty elektronicznej.
                            Użytkownik zobowiązany jest do bieżącego
                            monitorowania podanego adresu poczty elektronicznej
                            oraz numeru telefonu, a w przypadku ich zmiany, do
                            niezwłocznego poinformowania Novakid o powyższym
                            fakcie poprzez skontaktowanie się z obsługa
                            administracyjną Novakid poprzez czat, telefonicznie
                            lub wysyłając wiadomość e-mail.
                        </p>
                        <p class="terms_list_item">
                            5. Adres poczty elektronicznej wraz z numerem
                            telefonu jest powiązany z Kontem, stanowi konieczną
                            formę identyfikacji Użytkownika wobec Novakid i
                            będzie wykorzystywany do wszelkiej korespondencji
                            związanej ze świadczeniem Usług.
                        </p>
                        <p class="terms_list_item">
                            6. Novakid może odmówić utworzenia Konta, zablokować
                            lub usunąć istniejące Konto, jeżeli jego nazwa jest
                            już używana w ramach Platformy lub jeżeli Novakid
                            poweźmie uzasadnioną, wiarygodną informację, że jest
                            ona sprzeczna z prawem, dobrymi obyczajami, narusza
                            dobra osobiste osób trzecich lub uzasadnione
                            interesy Novakid lub postanowienia niniejszego
                            Regulaminu.
                        </p>
                        <p class="terms_list_item">
                            7. Użytkownik zobowiązuje się nie ujawniać
                            jakiejkolwiek osobie trzeciej Danych dostępowych i
                            ponosi wyłączną odpowiedzialność za szkody
                            wyrządzone na skutek ich ujawnienia.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §4
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZAWARCIE i REALIZACJA UMOWY
                        </h6>
                        <p class="terms_list_item">
                            1. Świadczenie usług drogą elektroniczną przez
                            Novakid jest możliwe po dokonaniu prawidłowej
                            Rejestracji, zaakceptowaniu przez Użytkownika
                            Regulaminu, a także wyrażeniu przez Użytkownika
                            zgody na przetwarzanie wizerunku swojego oraz
                            dziecka w trakcie i w celu zrealizowania Usługi
                            poprzez zaznaczenie odpowiedniego przycisku wyboru.
                        </p>
                        <p class="terms_list_item">
                            2. Użytkownik akceptując niniejszy Regulamin
                            oświadcza, że:
                        </p>
                        <ul>
                            <li>
                                3. a) podane dane są kompletne, zgodne ze stanem
                                faktycznym oraz nie naruszają jakichkolwiek praw
                                osób trzecich;
                            </li>
                            <li>
                                b) jest pełnoletni oraz uprawniony do zawarcia
                                Umowy.
                            </li>
                        </ul>
                        <p class="terms_list_item">
                            4. Przed rozpoczęciem świadczenia Usługi Użytkownik
                            zobowiązuje się do sprawdzenia warunków technicznych
                            sprzętu komputerowego oraz wykonania testu
                            wydajności łącza, poprawność działania mikrofonu
                            oraz kamery. Novakid zapewnia w ramach Platformy
                            funkcjonalność umożliwiająca sprawdzenie ww.
                            parametrów. W tym celu Użytkownik wybiera widoczną
                            poprzez Platformę opcję „Test sprzętu”.
                        </p>
                        <p class="terms_list_item">
                            5. Novakid świadczy Usługi wyłącznie dla Dzieci w
                            wieku od 4 do 12 lat. W indywidualnych przypadkach
                            Novakid może świadczyć Usługi dla Dzieci poniżej 4
                            oraz powyżej 12 roku życia – decyzję w tej sytuacji
                            podejmuje Novakid po każdorazowej weryfikacji
                            konkretnego przypadku.
                        </p>
                        <p class="terms_list_item">
                            6. Pierwsza lekcja próbna odbywa się bezpłatnie i ma
                            na celu zapoznanie się Użytkownika z Platformą i
                            formą świadczenia Usług, w tym określenie poziomu
                            znajomości języka przez Dziecko. Przeniesienie lub
                            anulowanie lekcji próbnej może nastąpić nie później,
                            niż na 8 (osiem) godzin przed jej rozpoczęciem. W
                            przypadku nie stawienia się przez Użytkownika na
                            lekcję próbną, Administratorzy mają prawo odmowy
                            ponownego jej przeprowadzenia. Jeśli w ustalonym
                            czasie rozpoczęcia lekcji próbnej Użytkownik nie
                            jest obecny przez pierwsze 5 (pięć) minut, Lektor ma
                            prawo przerwać oczekiwanie na Użytkownika i lekcja
                            uważa się za zakończoną, przy czym niezależnie od
                            czasu pojawienia się Użytkownika, za godzinę
                            rozpoczęcia lekcji uważa się tą, która określona
                            jest w Harmonogramie na Koncie Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            7. Użytkownik zainteresowany dalszym świadczeniem
                            przez Novakid Usług i odbyciem lekcji płatnych
                            wykupuje dostępne poprzez Konto Pakiety lekcji lub
                            Subskrypcję. Płatność możliwa jest wyłącznie w
                            formie bezgotówkowej za pomocą platformy
                            pośredniczącej w płatnościach internetowych
                            www.stripe.com. Użytkownik jest zobowiązany do
                            dokonania zapłaty przed rozpoczęciem świadczenia
                            Usługi.
                        </p>
                        <p class="terms_list_item">
                            8. Wszystkie ceny podane na stronach internetowych
                            Novakid są cenami brutto. Cena Pakietu lekcji lub
                            Subskrypcji podana na Stronie, Koncie lub Platformie
                            jest wiążąca w chwili wykupienia przez Użytkownika
                            danej Usługi.
                        </p>
                        <p class="terms_list_item">
                            9. Świadczenie usług przez Novakid odbywa się
                            poprzez Platformę. Użytkownik po zalogowaniu do
                            swojego Konta ma możliwość monitorowania Salda
                            lekcji lub Okresu subskrypcji. Zawierając Umowę z
                            Novakid Użytkownik jest świadomy wyboru danego
                            pakietu, czasu trwania jednej lekcji, a także ceny
                            za Usługę.
                        </p>
                        <p class="terms_list_item">
                            10. Z jednego Pakietu lekcji wykupionego przez
                            Użytkownika lub opłacanej Subskrypcji może
                            jednocześnie korzystać więcej niż jedno Dziecko
                            danego Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            11. Dla jednego Dziecka może być przypisany więcej
                            niż jeden Lektor.
                        </p>
                        <p class="terms_list_item">
                            12. Harmonogram świadczenia Usług, a także osoba
                            Lektora są ustalane wspólnie przez obsługę
                            administracyjną Novakid oraz Użytkownika. Użytkownik
                            ma prawo do zmiany Lektora, co zgłasza poprzez
                            wiadomość na czacie, e-mail lub telefonicznie
                            obsłudze administracyjnej Novakid, jednak nie
                            później niż na 8 godzin przed planowanym zgodnie z
                            harmonogramem rozpoczęciem lekcji.
                        </p>
                        <p class="terms_list_item">
                            13. Użytkownik ma prawo do zmiany lub anulowania
                            terminu świadczenia Usługi, jednak nie później niż
                            na 8 godzin przed planowanym zgodnie z harmonogramem
                            rozpoczęciem lekcji. Brak zgłoszenia zmiany lub
                            anulowania zgodnie z powyższym będzie równoznaczny z
                            odbyciem się lekcji w pierwotnie planowanym wedle
                            harmonogramu terminie.
                        </p>
                        <p class="terms_list_item">
                            14. Użytkownik chcąc anulować lub zmienić termin
                            świadczenia Usługi określonej harmonogramem może
                            dokonać powyższego:
                        </p>
                        <ul>
                            <li>
                                samodzielnie poprzez odpowiednią funkcjonalność
                                Platformy;
                            </li>
                            <li>
                                poprzez zgłoszenie na czacie, telefoniczne bądź
                                mailowe do obsługi administracyjnej Novakid.
                                Anulowanie lub zmiana terminu musi się odbyć nie
                                później niż na 8 godzin przed rozpoczęciem
                                Usługi. Przy planowaniu anulowania lub zmiany
                                terminu Usługi Użytkownik musi brać pod uwagę
                                godziny pracy obsługi administracyjnej. Jeśli
                                Użytkownik chce wprowadzić zmiany, dotyczące
                                harmonogramu Usługi, w godzinach, kiedy obsługa
                                administracyjna nie jest czynna, należy zrobić
                                to poprzez funkcjonalność Platformy.
                            </li>
                        </ul>
                        <p class="terms_list_item">
                            15. O skutecznie dokonanej zmianie lub anulowaniu
                            terminu świadczenia Usługi Użytkownik otrzymuje
                            powiadomienie na podany przez siebie numer telefonu
                            lub adres e-mail.
                        </p>
                        <p class="terms_list_item">
                            16. Brak gotowości do odbycia lekcji przez Dziecko w
                            terminie wynikającym z harmonogramu nie uprawnia do
                            zwrotu uiszczonej zapłaty. Jednak Użytkownik ma
                            prawo domagać się uznania, iż nieodbycie lekcji
                            nastąpiło z usprawiedliwionych przyczyn, a to w
                            trybie zgłoszenia reklamacji zgodnie z §15
                            niniejszego Regulaminu. Uwzględnienie reklamacji
                            będzie równoznaczne z przyznaniem mu prawa do
                            odbycia dodatkowej bezpłatnej lekcji.
                        </p>
                        <p class="terms_list_item">
                            17. Zmiana terminu lekcji na wniosek Lektora może
                            nastąpić nie później niż na 24 godziny przed
                            planowanym zgodnie z harmonogramem terminem
                            świadczenia Usługi.
                        </p>
                        <p class="terms_list_item">
                            18. Dwukrotne anulowanie przez Użytkownika
                            ustalonego terminu bezpłatnej lekcji wprowadzającej
                            uprawnia Novakid do odmowy przyznania danemu
                            Użytkownikowi lub jego Dziecku prawa do bezpłatnej
                            lekcji.
                        </p>
                        <p class="terms_list_item">
                            19. Zarówno Lektor jak i Użytkownik wraz z Dzieckiem
                            zobowiązują się do pozostawania w gotowości do
                            odbycia lekcji w terminie zgodnym z Harmonogramem.
                            Lektor będzie oczekiwał na Użytkownika przez cały
                            czas trwania lekcji. W przypadku bezpłatnej lekcji
                            próbnej Lektor będzie oczekiwał na Użytkownika przez
                            5 minut.
                        </p>
                        <p class="terms_list_item">
                            20. Każda lekcja trwa 25 minut, z tym zastrzeżeniem
                            iż spóźnienie Dziecka powoduje skrócenie jej trwania
                            o czas spóźnienia.
                        </p>
                        <p class="terms_list_item">
                            21. Użytkownik otrzymuje na wskazany przez siebie
                            numer telefonu lub adres e-mail przypomnienie o
                            zbliżającej się lekcji.
                        </p>
                        <p class="terms_list_item">
                            22. Lekcja, która nie odbyła się z powodu braku
                            gotowości Lektora, podlega bezpłatnemu przeniesieniu
                            na inny termin, wedle uznania Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            23. Użytkownik oświadcza, iż wyraża zgodę na
                            udostępnienie dźwięku i obrazu na swoim urządzeniu
                            teleinformatycznym tak aby poprzez Platformę możliwe
                            było prawidłowe wykonanie Usługi przez Novakid, tj.
                            odbycie lekcji z Lektorem przy jednoczesnym przesyle
                            obrazu i dźwięku zarówno ze strony Lektora, jak i
                            Użytkownika i Dziecka.
                        </p>
                        <p class="terms_list_item">
                            24. Novakid świadczy Usługę od poniedziałku do
                            niedzieli w godzinach od 09.00 do 20.30 CEST.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §5
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZASADY ŚWIADCZENIA USŁUG
                        </h6>
                        <p class="terms_list_item">
                            1. Novakid i działający w jej imieniu
                            Administratorzy zapewniają Użytkownikowi wykonanie
                            Usługi na warunkach określonych niniejszą Umową oraz
                            Pakietem lekcji lub Subskrypcją wybranymi przez
                            Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            2. Usługi świadczone przez Administratorów są
                            wykonywane zdalnie z wykorzystaniem technologii
                            informatycznych w oparciu o wykorzystanie globalnych
                            sieci komputerowych w celu zapewnienia Użytkownikowi
                            dostępu do niezbędnych materiałów Platformy oraz do
                            realizacji i zarządzania procesem prowadzenia lekcji
                            niezależnie od lokalizacji Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            3. Użytkownik poprzez Konto wykupuje określony
                            rodzaj Pakietu lekcji lub Subskrypcji aktualnie
                            oferowanych przez Novakid. Szczegółowe warunki
                            wybranego przez Użytkownika Pakietu lekcji lub
                            Subskrypcji stanowią integralną część Umowy.
                        </p>
                        <p class="terms_list_item">
                            4. Harmonogram świadczenia Usług, a także osoba
                            Lektora są ustalane wspólnie przez Administratorów
                            oraz Użytkownika przez odpowiednią sekcję na Koncie
                            Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            5. Użytkownik ma prawo do zmiany Lektora. Prośbę
                            wraz z uzasadnieniem o zmianę Lektora zgłasza
                            poprzez wysłanie wiadomości e-mail do
                            Administratorów lub poprzez czat dostępny na
                            Platformie, jednak nie później niż na 48
                            (czterdzieści osiem) godziny przed planowaną zgodnie
                            z harmonogramem lekcją. Administratorzy mają prawo
                            podjąć decyzję o zmianie Lektora w ciągu 48 godzin
                            od otrzymania prośby lub odmówić zmiany Lektora.
                        </p>
                        <p class="terms_list_item">
                            6. Administratorzy mogą polecać Lektorów według
                            własnego uznania, biorąc pod uwagę cel nauki języka,
                            poziom znajomości języka, wybraną kategorię Lektora
                            (“Premium” lub “Standard”), a także częstotliwość
                            lekcji z jaką Dziecko może się uczyć. Użytkownik
                            zostaje poinformowany, że Administratorzy określają
                            poziom znajomości języka Dziecka w celu sporządzenia
                            Harmonogramu lekcji i doboru Lektora, ocena ta ma
                            charakter informacyjny i może różnić się od oceny,
                            którą Użytkownik może otrzymać od osób trzecich. W
                            toku nauki Użytkownikowi mogą zostać zaoferowane
                            lekcje na różnych poziomach znajomości języka w celu
                            przećwiczenia określonej wiedzy i umiejętności na
                            zlecenie Lektora.
                        </p>
                        <p class="terms_list_item">
                            7. Harmonogram zajęć ustala się na podstawie
                            wybranego rodzaju Pakietu lekcji lub Subskrypcji
                            oraz wolnych terminów Lektora i Użytkownika.
                            Administratorzy mają prawo, ale nie są zobowiązani
                            do rezerwacji terminów u Lektora stałym
                            użytkownikom.
                        </p>
                        <p class="terms_list_item">
                            8. W przypadku, gdy Użytkownik nie zapłaci za Usługę
                            na 24 (dwadzieścia cztery) godziny przed
                            rozpoczęciem lekcji, zostaje ona anulowana.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §6
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZMIANA LUB ANULOWANIE TERMINU LEKCJI
                        </h6>
                        <p class="terms_list_item">
                            1. Zmiana lub anulowanie terminu lekcji przez
                            Użytkownika bez pobrania opłaty może nastąpić nie
                            później niż na 8 (osiem) godzin przed planowanym
                            zgodnie z Harmonogramem rozpoczęciem lekcji. Brak
                            zgłoszenia chęci zmiany lub anulowania zgodnie z
                            powyższym będzie równoznaczny z odbyciem się lekcji
                            w pierwotnie planowanym wedle Harmonogramu terminie
                            a brak gotowości do odbycia lekcji przez Dziecko nie
                            uprawnia do zwrotu uiszczonej zapłaty. Jednak
                            Użytkownik ma prawo domagać się uznania, iż
                            nieodbycie lekcji nastąpiło z usprawiedliwionych
                            przyczyn, a to w trybie zgłoszenia reklamacji
                            zgodnie z §15 niniejszego Regulaminu. Uwzględnienie
                            reklamacji będzie równoznaczne z przyznaniem mu
                            prawa do odbycia dodatkowej bezpłatnej lekcji.
                        </p>
                        <p class="terms_list_item">
                            2. Użytkownik ma prawo do jednorazowej zmiany
                            terminu lekcji na mniej niż 8 (osiem) godzin i nie
                            później niż 1 (jedną) godzinę przed planowanym
                            zgodnie z Harmonogramem rozpoczęciem lekcji, pod
                            warunkiem, że zmiana nastąpi na wolny termin w ciągu
                            najbliższego tygodnia kalendarzowego. W przypadku
                            braku wolnego terminu u Lektora prowadzącego w ciągu
                            najbliższego tygodnia, Użytkownik traci możliwość
                            zmiany, a lekcja odbędzie się zgodnie z pierwotnym
                            Harmonogramem. W przypadku, gdy Dziecko nie będzie
                            gotowe do odbycia lekcji w pierwotnym terminie
                            Użytkownik ma prawo do zgłoszenia reklamacji.
                        </p>
                        <p class="terms_list_item">
                            3. Użytkownik chcąc anulować lub zmienić termin
                            świadczenia Usługi określonej Harmonogramem może
                            dokonać powyższego:
                        </p>
                        <ul>
                            <li>
                                samodzielnie poprzez odpowiednią funkcjonalność
                                Platformy;
                            </li>
                            <li>
                                poprzez zgłoszenie poprzez czat, telefoniczne
                                bądź mailowe Administratorom Novakid. Przy
                                planowaniu anulowania lub zmiany terminu Usługi
                                Użytkownik musi brać pod uwagę godziny pracy
                                obsługi administracyjnej. Jeśli Użytkownik chce
                                wprowadzić zmiany, dotyczące harmonogramu
                                Usługi, w godzinach, kiedy obsługa
                                administracyjna nie jest czynna, należy zrobić
                                to poprzez funkcjonalność Platformy.
                            </li>
                        </ul>
                        <p class="terms_list_item">
                            4. O skutecznie dokonanej zmianie lub anulowaniu
                            terminu świadczenia Usługi Użytkownik otrzymuje
                            powiadomienie na podany przez siebie numer telefonu
                            lub adres e-mail.
                        </p>
                        <p class="terms_list_item">
                            5. Zmiana terminu lekcji na wniosek Lektora może
                            nastąpić nie później niż na 24 godziny przed
                            planowanym zgodnie z Harmonogramem terminem
                            świadczenia Usługi.
                        </p>
                        <p class="terms_list_item">
                            6. Lektor ma prawo do zmiany terminu lekcji (w
                            przypadku choroby lub innych ważnych powodów)
                            uprzedzając o tym Administratorów. W takim przypadku
                            Użytkownikowi przydzielany jest Lektor zastępczy.
                            Użytkownik ma prawo zrezygnować z lekcji z Lektorem
                            zastępczym w następujący sposób:
                        </p>
                        <ul>
                            <li>
                                poprzez zablokowanie opcji Lektora zastępczego
                                na Koncie Użytkownika
                            </li>
                            <li>powiadamiając o tym Administratorów,</li>
                        </ul>
                        <p class="terms_list_item">
                            7. W przypadku zrezygnowania przez Użytkownika z
                            lekcji z Lektorem zastępczym, jak też gdy nie udało
                            się znaleźć Lektora zastępczego, Użytkownik zostanie
                            powiadomiony o anulowaniu terminu lekcji.
                        </p>
                        <p class="terms_list_item">
                            8. Użytkownik może złożyć prośbę o zmianie Lektora w
                            przypadku, jeśli Lektor, według Użytkownika, zbyt
                            często zmienia ustalone z Harmonogramem terminy
                            lekcji. Na Koncie Użytkownika znajduje się opcja
                            “Zmiana nauczyciela”.
                        </p>
                        <p class="terms_list_item">
                            9. W przypadku, gdy Użytkownik nie pozostaje w
                            gotowości do odbycia lekcji zgodnie z Harmonogramem,
                            a jednocześnie nie zgłosił prośby o zmianę jej
                            terminu lub anulowanie zgodnie z zasadami
                            określonymi powyżej, lekcja jest uznawana za odbytą.
                        </p>
                        <p class="terms_list_item">
                            10. Lekcje, które nie odbyły się zgodnie z
                            Harmonogramem z winy Lektora podlegają bezpłatnemu
                            anulowaniu lub następuje zmiana ich terminu na inny
                            dogodny dla Użytkownika.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §7
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZAWIESZENIE ZAJĘĆ.
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZMIANY Z INICJATYWY ADMINISTRATORÓW
                        </h6>
                        <p class="terms_list_item">
                            1. Użytkownik ma prawo tymczasowo zawiesić lekcje,
                            ale jednocześnie, miejsce w Harmonogramie Lektora
                            staje się dostępne dla innych Użytkowników. Przy
                            wznowieniu zajęć, Użytkownik wraz z Administratorem
                            na nowo ustalają Harmonogram.
                        </p>
                        <p class="terms_list_item">
                            2. Administratorzy mają prawo zawiesić świadczenie
                            Usług z własnej inicjatywy w dni ustawowo wolne od
                            pracy w kraju Użytkownika lub w miejscu pracy
                            Administratorów, uprzednio informując o tym
                            Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            3. Administratorzy mają prawo do zmiany Lektora z
                            ważnych powodów (choroba, planowana nieobecność,
                            inne okoliczności). O zmianie Lektora
                            Administratorzy informują Użytkownika poprzez
                            e-mail, telefonicznie lub wiadomością SMS. W
                            przypadku, kiedy Użytkownik odmówi podjęcia nauki z
                            Lektorem zastępczym, Użytkownik ma prawo zawiesić
                            zajęcia w sposób określony niniejszą umową.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §8
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            SPOSOBY POWIADOMIEŃ
                        </h6>
                        <p class="terms_list_item">
                            1. Novakid informuje Użytkownika o ustaleniu,
                            anulowaniu lub zmianie terminu lekcji, przydzieleniu
                            Lektora zastępczego i innych wydarzeniach poprzez
                            wiadomość e-mail lub SMS. Wiadomości o nadchodzących
                            lekcjach na dzień i w dzień rozpoczęcia lekcji mają
                            charakter powiadomień, a Novakid nie gwarantuje ich
                            dostarczenia.
                        </p>
                        <p class="terms_list_item">
                            2. Brak gotowości do odbycia lekcji zgodnie z
                            Harmonogramem ze strony Dziecka z powodu braku
                            powiadomienia nie stanowi uzasadnionej przyczyny do
                            żądania ponownego jej przeprowadzenia w innym
                            terminie i w takim przypadku lekcja jest uznana za
                            odbytą. Obowiązkiem Użytkownika jest przestrzeganie
                            i kontrola Harmonogramu.
                        </p>
                        <p class="terms_list_item">
                            3. Użytkownik może powiadomić Administratora o
                            zmianie, anulowaniu lub tymczasowym zawieszeniu
                            lekcji lekcji poprzez czat lub wiadomość e-mail.
                            Wiadomości z informacją o zmianie, anulowaniu lub
                            tymczasowym zawieszeniu lekcji przyjmowane są tylko
                            w godzinach pracy (od 9.00 do 20.30). Na wiadomości,
                            które były wysłane na poprzez chat lub wiadomość
                            e-mail poza godzinami pracy, Administratorzy
                            odpowiadają w następny dzień roboczy w określonych
                            godzinach.
                        </p>
                        <p class="terms_list_item">
                            4. Użytkownik ma prawo poinformować Administratora o
                            chęci zwiększenia, zmiany liczby, a także czasu
                            trwania lekcji, zmiany Lektora, kontaktując się z
                            Administratorem w sposób określony w ust. 3
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §9
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            CENA I PŁATNOŚĆ
                        </h6>
                        <p class="terms_list_item">
                            1. Zapłata za Usługi następuje na zasadzie 100%
                            przedpłaty. Dostęp do Usług jest możliwy po
                            dokonaniu pełnej przedpłaty. Datą zapłaty jest data
                            wpływu środków na konto bankowe Novakid lub rachunek
                            osób trzecich uprawnionych do odbioru środków na
                            rzecz Novakid.
                        </p>
                        <p class="terms_list_item">
                            2. Zamówienie Usług odbywa się przez Użytkownika na
                            Platformie poprzez wybór i opłatę rodzaju Pakietu
                            lekcji lub Subskrypcji na Koncie Użytkownika i ich
                            opłacenie .
                        </p>
                        <p class="terms_list_item">
                            3. Przy opłacie Usług na Koncie Użytkownika,
                            Użytkownik wybiera sposób opłaty i wykonuje
                            czynności przewidziane regulaminami odpowiednich
                            systemów płatności elektronicznych oraz firm
                            obsługujących. Momentem płatności w tym przypadku
                            jest moment pozytywnego wyniku autoryzacji płatności
                            w wybranym systemie płatności.
                        </p>
                        <p class="terms_list_item">
                            4. Ilość lekcji, do których Użytkownik uzyskuje
                            dostęp po opłaceniu Usług, zależy od wybranego
                            Pakietu lekcji lub Subskrypcji.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §10
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            PAKIET LEKCJI i SUBSKRYPCJA
                        </h6>
                        <p class="terms_list_item">
                            1. W ramach Pakietu lekcji Novakid zobowiązuje się
                            do przeprowadzenia z góry ustalonej liczby lekcji,
                            stosownie do wybranego przez Użytkownika rodzaju
                            Pakietu, bez ograniczenia czasowego ich
                            wykorzystania, a Użytkownik do zapłaty określonej
                            ceny.
                        </p>
                        <p class="terms_list_item">
                            2. Poprzez Konto Użytkownik ma wgląd w aktualne
                            Saldo lekcji.
                        </p>
                        <p class="terms_list_item">
                            3. W ramach subskrypcji Novakid zobowiązuje się w
                            sposób ciągły do przeprowadzenia określonej
                            tygodniowo oznaczonej liczby lekcji, świadczonych
                            przez czas trwania subskrypcji, a Użytkownik do
                            zapłaty określonej ceny.
                        </p>
                        <p class="terms_list_item">
                            4. Podstawowy Okres subskrypcji wynosi 28
                            kalendarzowych dni, ale może być zmieniony
                            (skrócony), jeśli ilość zajęć ustalonych przez
                            Ucznia w okresie Subskrypcji przekroczy ilość Usług
                            zawartych w aktualnej Subskrypcji Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            5. Użytkownik opłaca Subskrypcję kartą kredytową i
                            przy pomocy zewnętrznego serwisu płatniczego.
                            Pierwsza płatność jest dokonywana przez Użytkownika
                            z wpisaniem danych z karty, następnie dla
                            subskrypcji na 4 tygodnie tworzony jest plan
                            płatności zgodnie z wybranym okresem subskrypcji,
                            zgodnie z którym operator usług płatniczych
                            automatycznie pobierze określoną kwotę z karty.
                            Jeśli kolejna płatność nie zostanie zrealizowana z
                            powodu braku środków na karcie lub z innego powodu,
                            system wyśle powiadomienie i ponowi próbę pobrania
                            środków jeszcze dwa razy w odstępie 24 h (dwudziestu
                            czterech) godzin. W przypadku długich subskrypcji
                            (12 lub 24 tygodni) system nie tworzy planu
                            płatności ani nie pobiera kolejnych opłat
                            automatycznie.
                        </p>
                        <p class="terms_list_item">
                            6. Novakid informuje Użytkownika o zbliżającej się
                            płatności za Subskrypcję poprzez wiadomości SMS.
                            Wiadomości wysyłane klientowi mają charakter
                            powiadomień. Novakid nie gwarantuje dostarczenia
                            wiadomości.
                        </p>
                        <p class="terms_list_item">
                            7. Subskrypcja na 4 tygodnie zakłada automatyczne
                            pobranie środków za Usługę co 28 dni od daty opłaty
                            lub przedłużenia Subskrypcji. W przypadku braku
                            zgody na powyższą kolejność płatności z Usługi,
                            Użytkownik ma prawo wysłać stosowną prośbę o
                            dezaktywację Subskrypcji do Administratorów poprzez
                            wiadomość e-mail lub poprzez czat albo poprzez
                            przycisk “Anuluj Subskrypcję” na Koncie Użytkownika.
                            W ramach długiej subskrypcji użytkownik opłaca z
                            góry 3 lub 6 Okresów subskrypcji po 4 tygodnie i
                            automatyczne pobranie środków nie następuje, a
                            niewykorzystane w ramach każdego Okresu subskrypcji
                            lekcje wygasają.
                        </p>
                        <p class="terms_list_item">
                            8. Użytkownik ma możliwość zmiany Pakietu lekcji na
                            Subskrypcję wybierając odpowiednią opcję przy
                            zapłacie. Wówczas, w momencie wykupienia
                            Subskrypcji, lekcje znajdujące się na Saldzie są
                            przeliczane na Bilans bonusowy, przy założeniu, że 1
                            punkt bonusowy jest równy 1 zł. Użytkownik otrzymuje
                            liczbę bonusów w przeliczeniu proporcjonalnym do
                            iloczynu liczby lekcji na Saldzie i ich
                            jednostkowego kosztu. Przy kolejnym pobraniu środków
                            za Subskrypcję z Bilansu bonusowego pobierane są
                            środki, co umożliwia zmniejszenie kosztu Subskrypcji
                            o 25% jej kosztu.
                        </p>
                        <p class="terms_list_item">
                            9. Użytkownik ma możliwość zmiany Subskrypcji na
                            Pakiet lekcji poprzez wysłanie prośby o zmianę
                            Subskrypcji na Pakiet Usług przez wiadomość e-mail
                            lub poprzez czat do Administratorów. Administratorzy
                            zobowiązani są do anulowania przedłużenia
                            subskrypcji. Po wygaśnięciu anulowanej Subskrypcji,
                            Użytkownik będzie mógł wykupić Pakiet lekcji.
                            Wówczas lekcje, do których przeprowadzenia byłby
                            uprawniony w ramach anulowanej subskrypcji, są
                            przeliczane na Bilans bonusowy w wysokości 50%
                            wartości lekcji.
                        </p>
                        <p class="terms_list_item">
                            10. Użytkownik ma możliwość zawieszenia subskrypcji
                            na okres od 1 do 4 tygodni. W tym przypadku, wartość
                            niewykorzystanych lekcji zostanie w całości
                            zaksięgowana na Bilansie bonusowym.
                        </p>
                        <p class="terms_list_item">
                            11. Użytkownik ma możliwość wykorzystania Bonusów
                            lub promocji i do dokonania częściowej płatności za
                            pośrednictwem Bonusów przysługujących w ramach
                            Salda. Użytkownik zgadza się z tym, że zasady
                            programów bonusowych i promocji są ustalane i
                            zmieniane przez Administratorów jednostronnie, z
                            14-dniowym wyprzedzeniem czasowym, a Administratorzy
                            zobowiązani są do poinformowania Użytkownika o tych
                            zmianach. Informacje o programach bonusowych i
                            trwających promocjach, a także warunkach ich
                            gromadzenia i realizacji są zamieszczane na Stronie
                            i/lub Koncie Użytkownika na Platformie, a także w
                            sieciach społecznościowych Novakid i stanowią
                            integralną część niniejszej Umowy.
                        </p>
                        <p class="terms_list_item">
                            13. Płatności za Usługi są przetwarzane przez Stripe
                            (zwane dalej „Centrum Przetwarzania”), działając na
                            podstawie umowy zawartej z Administratorami.
                            Administratorzy mają prawo do podłączania
                            alternatywnych ośrodków przetwarzania. Wszelkie
                            prawa i obowiązki wynikające z procesu
                            rozliczeniowego powstają bezpośrednio pomiędzy
                            Centrum Przetwarzania a Użytkownikiem.
                        </p>
                        <p class="terms_list_item">
                            14. Administracja nie sprawuje kontroli nad
                            kompleksem sprzętowo-programowym elektronicznych
                            systemów płatności i nie ponosi odpowiedzialności za
                            błędy w takim kompleksie sprzętowym i technicznym.
                            Jeżeli w wyniku takich błędów środki Użytkownika
                            zostały obciążone, ale płatność nie została
                            autoryzowana, obowiązek zwrotu środków Użytkownikowi
                            spoczywa na dostawcy elektronicznego systemu
                            płatności.
                        </p>
                        <p class="terms_list_item">
                            15. Użytkownik samodzielnie płaci za powiązane
                            usługi stron trzecich (w tym usługi komunikacyjne,
                            Internet itp.) niezbędne do korzystania z usług
                            Platformy Novakid.
                        </p>
                        <p class="terms_list_item">
                            16. Administracja nie przetwarza danych osobowych
                            płatników przekazanych do rozliczeń za pośrednictwem
                            Centrum Przetwarzania. Novakid nie przechowuje
                            danych kart bankowych płatników w swoich zasobach, w
                            tym serwerach, technologiach chmurowych itd.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §11
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            WYMAGANIA TECHNICZNE
                        </h6>
                        <p class="terms_list_item">
                            1. Aby korzystać z Platformy i Usług Novakid
                            niezbędny jest:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) komputer z systemem operacyjnym: Windows 7/8
                                / 8.1 / 10, Mac OS X 10.9, 10.10, 10.11; Pamięć
                                RAM: 2 GB; Procesor: Intel Core 2 Duo 1.8 GHz
                                (lub analogiczny);
                            </p>
                            <p class="terms_list_item">
                                b) przeglądarka internetowa Google Chrome wersja
                                stabilna z aktywną automatyczną aktualizacją;
                            </p>
                            <p class="terms_list_item">
                                c) sprawny mikrofon i kamera video;
                            </p>
                            <p class="terms_list_item">
                                d) łącze internetowe o przepustowości
                                przynajmniej 5Mb/s
                            </p>
                            <p class="terms_list_item">
                                2. Rekomendowane przez Novakid wymagania
                                techniczne to:
                            </p>
                        </ul>
                        <ul>
                            <p class="terms_list_item">
                                a) komputer z systemem operacyjnym Windows 8 /
                                8.1 / 10, Mac OS X 10.10, 10.11; Pamięć RAM: 4
                                GB lub wyższa; Procesor: Intel Core 2 Duo 2.2
                                GHz (lub analogiczny);
                            </p>
                            <p class="terms_list_item">
                                b) przeglądarka internetowa Google Chrome wersja
                                stabilna z aktywną automatyczną aktualizacją;
                            </p>
                            <p class="terms_list_item">
                                c) sprawny mikrofon i kamera video
                            </p>
                            <p class="terms_list_item">
                                d) łącze internetowe o przepustowości
                                przynajmniej 35Mb/s lub wyższej
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            3. Zaleca się zamknięcie przez Użytkownika wszelkich
                            programów, które mogą obciążać łączę internetowe.
                        </p>
                        <p class="terms_list_item">
                            4. Koszty dostępu do Internetu ponosi Użytkownik,
                            także w przypadku korzystania z Internetu za pomocą
                            telefonu komórkowego. Użytkownicy korzystający z
                            Usług za pomocą telefonu komórkowego powinni
                            zapoznać się ze stawkami transferu (połączeń z
                            Internetem) stosowanymi przez operatorów
                            telekomunikacyjnych.
                        </p>
                        <p class="terms_list_item">
                            5. Operator wykorzystuje pliki cookie wyłącznie w
                            celu gromadzenia informacji związanych z
                            korzystaniem z Platformy przez Użytkownika, a w
                            szczególności w celu:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a. utrzymania sesji Użytkownika (po zalogowaniu
                                do Platformy), dzięki której Użytkownik nie musi
                                na każdej podstronie ponownie wpisywać hasła;
                            </p>
                            <p class="terms_list_item">
                                b. dostosowania Platformy do potrzeb
                                Użytkowników; oraz
                            </p>
                            <p class="terms_list_item">
                                c. tworzenia statystyk oglądalności Strony.
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            Szczegółowe informacje o wykorzystywaniu plików
                            cookies znajdują się w Polityce prywatności.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §12
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            PRAWA I OBOWIĄZKI UŻYTKOWNIKA
                        </h6>
                        <p class="terms_list_item">
                            Szczegółowe 1. Użytkownik zobowiązany jest do:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) korzystania z Platformy w sposób
                                niezakłócający jej funkcjonowania;
                            </p>
                            <p class="terms_list_item">
                                b) korzystania z Platformy w sposób zgodny z
                                przepisami prawa polskiego oraz postanowieniami
                                Regulaminu;
                            </p>
                            <p class="terms_list_item">
                                c) informowania Novakid o wszelkich usterkach
                                Platformy;
                            </p>
                            <p class="terms_list_item">
                                d) niepodejmowania prób złamania zabezpieczeń
                                Platformy;
                            </p>
                            <p class="terms_list_item">
                                e) niemodyfikowania i nieingerowania w
                                jakimkolwiek stopniu w kod źródłowy
                                oprogramowania Platformy;
                            </p>
                            <p class="terms_list_item">
                                f) nieingerowania w bazy danych dostępnych
                                poprzez Platformę;
                            </p>
                            <p class="terms_list_item">
                                g) niemodyfikowania w jakimkolwiek celu Usługi
                                Platformy, znaków towarowych, opisów oraz
                                pozostałych danych i przedmiotów praw własności
                                intelektualnej zawartych na Stronie;
                            </p>
                            <p class="terms_list_item">
                                h) niedostarczania i nieprzekazywania treści
                                zabronionych w Platformie, w szczególności
                                podczas lekcji, takich na przykład jak
                                przedstawiających: treści pornograficzne,
                                nagość, przezroczyste ubrania, lubieżne lub
                                prowokacyjne pozy, zbliżenia intymnych części
                                ciała lub propagujące przemoc, nawołujące do
                                nienawiści, obraźliwe lub naruszające prawo do
                                prywatności; ponadto, komentarze, opinie, oceny
                                i wiadomości Użytkownika nie mogą zawierać
                                treści wulgarnych, obraźliwych, niezgodnych z
                                prawem oraz z ogólnie przyjętymi normami
                                społecznymi;
                            </p>
                            <p class="terms_list_item">
                                i) korzystania z Usług oferowanych przez Novakid
                                w sposób nieuciążliwy dla pozostałych
                                Użytkowników, Lektorów oraz dla Novakid z
                                poszanowaniem ich dóbr osobistych i wszelkich
                                przysługujących im praw;
                            </p>
                            <p class="terms_list_item">
                                j) niepodejmowania jakichkolwiek działań
                                mających na celu obejście zabezpieczeń, czy też
                                zakłócających stabilność i funkcjonalność
                                autoryzowanych serwerów lub oprogramowania
                                Platformy;
                            </p>
                            <p class="terms_list_item">
                                k) korzystania z wszelkich Treści zamieszczonych
                                w ramach Platformy jedynie w zakresie własnego
                                użytku osobistego;
                            </p>
                            <p class="terms_list_item">
                                l) niezamieszczania Treści lub wypowiedzi
                                mających charakter reklamy lub o charakterze
                                komercyjnym, naruszających dobre obyczaje lub
                                dobry wizerunek Novakid lub Platformy;
                            </p>
                            <p class="terms_list_item">
                                m) dostarczania wyłącznie Treści, do których
                                zamieszczenia w Platformie Użytkownik jest
                                uprawniony;
                            </p>
                            <p class="terms_list_item">
                                n) uczestniczenia w lekcji z Lektorem w sposób
                                merytoryczny, uprzejmy oraz zgodny z materiałami
                                opracowanymi przez Novakid lub danego Lektora, a
                                także sprawowania nadzoru i dbałości o to, aby
                                Dziecko korzystało z Usług w taki sam sposób;
                            </p>
                            <p class="terms_list_item">
                                o) nienagrywania i niepublikowania poza
                                Platformą poszczególnych lekcji z Lektorem, ich
                                części lub slajdów, odbywanych w ramach
                                świadczenia Usługi.
                            </p>
                            <p class="terms_list_item">
                                p) przekazywać Administratorom prawdziwe i
                                kompletne dane niezbędne dla okazania wykonania
                                usług. Podane informacje muszą być prawdziwe i
                                kompletne.
                            </p>
                            <p class="terms_list_item">
                                r) przestrzegać ustalonego harmonogramu lekcji
                                oraz zasad ich odwoływania;, odwoływanie ich i
                                zmienianie planu w odpowiednim czasie.
                            </p>
                            <p class="terms_list_item">
                                s) nie udostępniać Konta Użytkownika osobom
                                trzecim;
                            </p>
                            <p class="terms_list_item">
                                t) niezwłocznie powiadomić Administratorów o
                                jakimkolwiek przypadku nieuprawnionego dostępu
                                do Konta lub Platformy;
                            </p>
                            <p class="terms_list_item">
                                u) nie naruszać praw intelektualnych Novakid i
                                nie przekazywać wyników pracy intelektualnej
                                pracowników Novakid osobom trzecim. Nie kopiować
                                i nie rozpowszechniać materiałów Platformy;
                            </p>
                            <p class="terms_list_item">
                                w) nie kopiować i nie rozpowszechniać materiałów
                                Platformy;
                            </p>
                            <p class="terms_list_item">
                                x) odrabiać prace domowe zadane przez Lektora
                                podczas lekcji;
                            </p>
                            <p class="terms_list_item">
                                y) nie udostępniać danych do logowania na
                                Platformę osobom trzecim. Strony zgadzają się z
                                tym, że wszelkie czynności wykonywane na Profilu
                                Użytkownika przy użyciu loginu i hasła
                                Użytkownika, uważa się za popełnione przez
                                Użytkownika.
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            2. Użytkownik ma prawo do:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) nieprzerwanego dostępu do Platformy oraz
                                Konta, z zastrzeżeniem postanowień Regulaminu;
                            </p>
                            <p class="terms_list_item">
                                b) dostępu poprzez Platformę do archiwalnych
                                nagrań audiowizualnych z lekcji, zadań domowych
                                i innych materiałów umieszczonych na Platformie;
                            </p>
                            <p class="terms_list_item">
                                c) odstąpienia od zawartej Umowy w terminie 14
                                dni od daty jej zawarcia, z zastrzeżeniem
                                postanowień Regulaminu;
                            </p>
                            <p class="terms_list_item">
                                d) korzystania z Platformy i zamieszczonych na
                                niej materiałów zgodnie z jej funkcjonalnym
                                przeznaczeniem i zamieszczonych materiałów i w
                                granicach określonych Umową;.
                            </p>
                            <p class="terms_list_item">
                                e) Wymagać od Administratorów, aby wykonywali
                                swoje zobowiązania wynikające z niniejszej Umowy
                                w terminie i z należytą jakością, chyba, że
                                warunki niniejszej Umowy stanowią inaczej.
                                Lekcję uważa się za przeprowadzoną prawidłowo,
                                jeśli w ciągu 24h od jej przeprowadzenia
                                Użytkownik nie zgłosi reklamacji Administratorom
                                co do jakości lekcji. Administratorzy
                                zastrzegają sobie prawo do indywidualnego
                                rozpatrzenia reklamacji Użytkownika i, w
                                przypadku pojawienia się uzasadnionych powodów,
                                decyzją Administratorów, do zwrócenia lekcji.
                            </p>
                            <p class="terms_list_item">
                                f) Wysłać prośbę o zmianę lektora z
                                uzasadnieniem tej prośby. W tym przypadku,
                                Administratorzy mają prawo podjąć decyzję o
                                zmianie lektora w ciągu 48h od wysłania prośby.
                            </p>
                            <p class="terms_list_item">
                                g) Odwoływać lub zmienić datę i (lub) godzinę
                                lekcji na warunkach określonych w punkcie 5 i 6
                                niniejszej Umowy.
                            </p>
                            <p class="terms_list_item">
                                h) Tymczasowo zawiesić lekcje, ale jednocześnie
                                wolne terminy w grafiku Lektora pozostają
                                dostępne dla innych Użytkowników. Wznawiając
                                zajęcia, Użytkownik i Administrator na nowo
                                ustalają grafik zajęć.
                            </p>
                            <p class="terms_list_item">
                                i) Dostępu do zadań domowych i innych materiałów
                                umieszczonych na platformie.
                            </p>
                        </ul>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §13
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            PRAWA I OBOWIĄZKI NOVAKID
                        </h6>
                        <p class="terms_list_item">
                            1. Novakid jest zobowiązany jest do:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) zapewnienia dostępu do Platformy w czasie
                                wskazanym w Regulaminie, chyba że wystąpią
                                przyczyny opisane w Regulaminie;
                            </p>
                            <p class="terms_list_item">
                                b) niezwłocznej naprawy zgłaszanych przez
                                Użytkownika usterek w świadczeniu Usługi;
                            </p>
                            <p class="terms_list_item">
                                c) wybrania Lektorów przeprowadzających lekcje w
                                ramach Usługi z zachowaniem należytej
                                staranności;
                            </p>
                        </ul>
                        <p class="terms_list_item">2. Novakid ma prawo do:</p>
                        <ul>
                            <p class="terms_list_item">
                                a) przejściowego, krótkotrwałego zaprzestania
                                utrzymywania Platformy ze względu na czynności
                                konserwacyjne lub związane z modyfikacją
                                Platformy albo ze względu na działanie siły
                                wyższej;
                            </p>
                            <p class="terms_list_item">
                                b) wysyłania na adres e‐mail danego Użytkownika
                                komunikatów technicznych związanych z
                                funkcjonowaniem Platformy i realizacją Usługi
                                oraz nowymi funkcjonalnościami w Platformie;
                            </p>
                            <p class="terms_list_item">
                                c) zablokowania Konta Użytkownikom, których
                                działania lub zaniechania naruszają
                                postanowienia powszechnie obowiązującego prawa
                                lub postanowienia Regulaminu;
                            </p>
                            <p class="terms_list_item">
                                d) korzystać z usług dowolnych osób fizycznych i
                                prawnych w celu terminowego i wysokiej jakości
                                wypełnienia usług wynikających z Umowy;.
                            </p>
                            <p class="terms_list_item">
                                e) żądać od Użytkownika terminowego opłacania
                                kosztów Usług zgodnie z warunkami niniejszej
                                umowy;.
                            </p>
                            <p class="terms_list_item">
                                f)nagrywania lekcji audio i wideo, w celu
                                kontroli jakości kształcenia;.
                            </p>
                            <p class="terms_list_item">
                                g) wykorzystywanie adresu e-mail, numeru
                                telefonu i innych danych, które użytkownik
                                Użytkownik podał podczas rejestracji na Stronie
                                i na Platformie do wysyłania Użytkownikowi
                                materiałów informacyjnych i reklamowych, w tym
                                celu informowania Użytkownika o działaniach
                                Platformy i przebiegu Umowy. Rejestrując się na
                                Stronie i/lub korzystając z usług Platformy,
                                Użytkownik może wyrazić zgodę na przetwarzanie
                                jego danych osobowych w powyższym celu przez
                                Administratorów lub strony trzecie zaangażowane
                                przez Administratorów w celu spełnienia warunków
                                niniejszej Umowy.
                            </p>
                            <p class="terms_list_item">
                                h) z uzasadnionych przyczyn odmówić
                                Użytkownikowi świadczenia i roszczenia Usług bez
                                wyjaśnienia przyczyn, z jednoczesnym obowiązkiem
                                zwrotu pieniędzy za niewykorzystane lekcje, z
                                wyjątkiem tych lekcji, które były przyznane jako
                                bonus lub prezent;.
                            </p>
                            <p class="terms_list_item">
                                i) bez bez konsultacji z Użytkownikiem
                                modyfikować i uaktualniać interfejsy i usługi
                                Platformy/Strony, dodawać nowe materiały;.
                            </p>
                        </ul>
                        <p class="terms_list_item">samodzielnie określać:</p>
                        <ul>
                            <p class="terms_list_item">
                                j) format pracy Platformy;
                            </p>
                            <p class="terms_list_item">
                                k) ustalać koszt Usługi dla Użytkownika;
                            </p>
                            <p class="terms_list_item">
                                l) ustalać formy promocji i/lub reklamy w celu
                                dla przyciągnięcia Użytkowników na Platformę;
                            </p>
                            <p class="terms_list_item">
                                m)korzystając z Platformy w dowolnym czasie i
                                dowolnej ilości wysyłać Użytkownikowi wiadomości
                                z informacją, potwierdzające fakt korzystania z
                                Platformy i/lub dostarczających informacji,
                                które są istotne dla efektywnego korzystania z
                                Platformy, w tym wiadomości o zmianach w
                                Harmonogramie, rozpoczęciu lekcji, zadanej pracy
                                domowej itd.;
                            </p>
                            <p class="terms_list_item">
                                n)tymczasowo zawiesić świadczenie Usług w ramach
                                niniejszej Umowy z uzasadnionych przyczyn
                                technicznych, technologicznych lub innych
                                utrudniających świadczenie Usług, na okres
                                usunięcia powyższych przyczyn.
                            </p>
                            <p class="terms_list_item">
                                o) zmienić lektora z uzasadnionych powodów
                                (tymczasowa niezdolność do pracy, urlop, inne
                                okoliczności). O zmianie Lektora Administratorzy
                                informują Użytkownika za pomocą różnych kanałów
                                komunikacji wiadomości e-mail, SMS,
                                telefonicznie.
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            3. Novakid oświadcza i zapewnia, że:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) będzie przetwarzał dane osobowe zgodnie z
                                właściwymi przepisami prawa polskiego, a także
                                europejskiego, w szczególności z uwzględnieniem
                                przepisów ustawy z dnia 10 maja 2018 r. o
                                ochronie danych osobowych, a także
                                rozporządzenia Parlamentu Europejskiego i Rady
                                (UE) 2016/79 z dnia 27 kwietnia 2016 r. w
                                sprawie ochrony osób fizycznych w związku z
                                przetwarzaniem danych osobowych i w sprawie
                                swobodnego przepływu takich danych oraz
                                uchylenia dyrektywy 95/46/WE (ogólne
                                rozporządzenie o ochronie danych), a także
                                zgodnie z obowiązkowymi zasadami ochrony danych
                                osobowych określonymi w klauzuli 5 ust. 1 lit.
                                b) decyzji Komisji Europejskiej z dnia 15
                                czerwca 2001 r. numer 2001/497/WE w sprawie
                                standardowych klauzul umownych w związku z
                                przekazywaniem danych osobowych do państw
                                trzecich na podstawie Dyrektywy 95/46/WE
                                Parlamentu Europejskiego i Rady z dnia 24
                                października 1995 r. w sprawie ochrony osób
                                fizycznych w zakresie przetwarzania danych
                                osobowych oraz swobodnego przepływu tych danych
                                (Dz. Urz. WE L 181/19, z 4.07.2001),
                            </p>
                            <p class="terms_list_item">
                                b) będzie odpowiadać wyczerpująco i w rozsądnym
                                terminie na zapytania Prezesa Urzędu Ochrony
                                Danych Osobowych, a także na zapytania
                                Użytkownika związane z przetwarzaniem jego
                                danych osobowych, a także ich przekazywaniem do
                                państw trzecich spoza UE oraz będzie
                                przestrzegał zaleceń udzielonych przez Prezesa
                                Urzędu Ochrony Danych Osobowych, a także
                                udostępni mu swoje urządzenia do przetwarzania
                                danych osobowych w celu kontroli,
                            </p>
                            <p class="terms_list_item">
                                c) w związku z tym, że dane osobowe Użytkowników
                                są również przetwarzane przez pracowników
                                Novakid w jednostkach organizacyjnych
                                znajdujących się na terenie Federacji
                                Rosyjskiej. nie ma żadnego powodu, aby sądzić,
                                że ustawodawstwo Federacji Rosyjskiej
                                uniemożliwia mu wypełnianie zobowiązań
                                wynikających z umowy, a w przypadku zmiany tego
                                ustawodawstwa, która mogłaby mieć znaczący
                                negatywny skutek dla udzielonych gwarancji,
                                powiadomi o tej zmianie Prezesa Urzędu Ochrony
                                Danych Osobowych, a także wstrzyma przekazywanie
                                danych do Federacji Rosyjskiej.
                            </p>
                        </ul>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §14
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ODPOWIEDZIALNOŚĆ
                        </h6>
                        <p class="terms_list_item">
                            1. Novakid nie ponosi odpowiedzialności za
                            jakiekolwiek działania Użytkownika.
                        </p>
                        <p class="terms_list_item">
                            2. Novakid nie ponosi odpowiedzialności za rezultat
                            prowadzonego kursu języka angielskiego.
                        </p>
                        <p class="terms_list_item">
                            3. Novakid nie ponosi odpowiedzialności za problemy
                            techniczne bądź ograniczenia techniczne w sprzęcie
                            komputerowym Użytkownika, które uniemożliwiają mu
                            korzystanie z Platformy lub Usługi.
                        </p>
                        <p class="terms_list_item">
                            4. Novakid nie ponosi odpowiedzialności z tytułu
                            naruszenia praw osób trzecich oraz wyrządzenia
                            osobom trzecim szkody na skutek lub w związku z
                            działaniami prowadzonymi przez Użytkownika, w
                            szczególności w przypadku naruszenia przez
                            Użytkowników praw autorskich i innych praw własności
                            intelektualnej przysługujących osobom trzecim.
                        </p>
                        <p class="terms_list_item">
                            5. Novakid dokłada należytej staranności wynikającej
                            z profesjonalnego charakteru jego działalności przy
                            nadzorowaniu metodyki nauczania stosowanej przez
                            Lektorów.
                        </p>
                        <p class="terms_list_item">
                            6. Novakid nie ponosi odpowiedzialności za przerwy w
                            funkcjonowaniu Platformy oraz przerwy w świadczeniu
                            Usługi mające miejsce na skutek działania siły
                            wyższej rozumianej jako zdarzenie, którego nie dało
                            się przewidzieć i którego skutkom nie dało się
                            zapobiec. W przypadku wystąpienia przypadku siły
                            wyższej Novakid zobowiązana jest do poinformowania
                            Użytkownika o przerwie w świadczeniu Usługi i
                            podania jej przyczyny.
                        </p>
                        <p class="terms_list_item">
                            7. Novakid zapewnia, że Administratorzy będą
                            wykonywali swoje zobowiązania wynikające z
                            niniejszej Umowy w terminie i z należytą jakością.
                        </p>
                        <p class="terms_list_item">
                            8. Novakid zobowiązuje się do naprawienia szkody,
                            którą Użytkownik poniósł w wyniku zawinionego
                            naruszenia przez Novakid obowiązków i gwarancji
                            określonych w §7, §13, §15 Regulaminu.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §15
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            REKLAMACJE
                        </h6>
                        <p class="terms_list_item">
                            1. Użytkownik uprawniony jest do złożenia reklamacji
                            związanej ze świadczeniem Usługi przez Novakid.
                            Reklamacja może zostać złożona drogą elektroniczną
                            poprzez wysłanie wiadomości e-mail do obsługi
                            administracyjnej Novakid.
                        </p>
                        <p class="terms_list_item">
                            1.2 Reklamacje dotyczące nieprawidłowego
                            przeprowadzenia lekcji przez Lektora należy zgłosić
                            w terminie 24 godzin od jej odbycia. Po upływie ww.
                            terminu lekcja jest uważana za odbytą w sposób
                            prawidłowy.
                        </p>
                        <p class="terms_list_item">
                            1.3 Reklamacje dotyczące świadczenia usług w
                            pozostałym zakresie niż wymieniony w ust. 2 należy
                            zgłosić w terminie 7 dni od zaistnienia zdarzenia
                            będącego podstawą reklamacji.
                        </p>
                        <p class="terms_list_item">
                            1.4 Administratorzy zastrzegają sobie prawo do
                            indywidualnego rozpatrzenia reklamacji Użytkownika i
                            w przypadku pojawienia się uzasadnionych powodów do
                            zwrócenia lekcji.
                        </p>
                        <p class="terms_list_item">
                            2. Reklamacja powinna zawierać dane Użytkownika oraz
                            opis zgłaszanych zastrzeżeń.
                        </p>
                        <p class="terms_list_item">
                            3. Novakid najpóźniej w terminie 14 dni od daty
                            otrzymania reklamacji, ustosunkuje się do złożonej
                            reklamacji i poinformuje Użytkownika o dalszym
                            postępowaniu. W przypadku, gdy reklamacja będzie
                            uzasadniona Novakid poinformuje Użytkownika o
                            proponowanym sposobie realizacji reklamacji. W
                            przypadku stwierdzenia przez Novakid konieczności
                            uzupełniania reklamacji przez Użytkownika, Novakid
                            niezwłocznie skontaktuje się z Użytkownikiem.
                        </p>
                        <p class="terms_list_item">
                            4. Jeżeli reklamacja zostanie odrzucona Użytkownik
                            może zwrócić się do miejskiego lub powiatowego
                            rzecznika konsumentów. Bezpłatne informacje
                            udzielane są telefonicznie, pocztą elektroniczną
                            bądź bezpośrednio w biurze rzecznika. Adres i
                            telefon odpowiedniego rzecznika można znaleźć w
                            Starostwie Powiatowym lub Urzędzie Miasta, a także
                            na stronie internetowej Urzędu Ochrony Konkurencji i
                            Konsumentów.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §16
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ZGŁASZANIE BEZPRAWNYCH TREŚCI
                        </h6>
                        <p class="terms_list_item">
                            1. Użytkownik ponosi wyłączną odpowiedzialność za
                            charakter zamieszczonych przez siebie Treści oraz
                            uczestnictwo w lekcjach. Operator nie ponosi żadnej
                            odpowiedzialności za Treści, z zastrzeżeniem art. 14
                            Ustawy o świadczeniu usług drogą elektroniczną.
                        </p>
                        <p class="terms_list_item">
                            2. W przypadku powzięcia przez Użytkownika
                            informacji o fakcie zamieszczenia na Platformie
                            Treści naruszających Regulamin, powinna ona
                            niezwłocznie zgłosić taki fakt, kontaktując się z
                            obsługa administracyjną Novakid.
                        </p>
                        <p class="terms_list_item">
                            3. Zabronione jest zamieszczanie w ramach Platformy
                            bezprawnych Treści lub Treści, z którymi jest
                            związana bezprawna działalność.
                        </p>
                        <p class="terms_list_item">
                            4. Novakid zastrzega sobie prawo do uniemożliwiania
                            dostępu do tych Treści, co do których stwierdzono,
                            że są one bezprawne lub jest z nimi związana
                            bezprawna działalność. Novakid nie prowadzi
                            uprzedniej oraz bieżącej kontroli zamieszczanych
                            Treści.
                        </p>
                        <p class="terms_list_item">
                            5. W przypadku, gdy w wyniku zamieszczenia przez
                            Użytkownika w ramach Platformy danej Treści dojdzie
                            do naruszenia praw osób trzecich lub przepisów
                            obowiązującego prawa lub wyrządzenia osobie trzeciej
                            szkody przez Użytkownika, Użytkownik jest
                            zobowiązany do pełnego pokrycia szkody poniesionej w
                            związku z tym naruszeniem.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §17
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ODSTĄPIENIE OD UMOWY ORAZ ZAPRZESTANIE KORZYSTANIA Z
                            PLATFORMY
                        </h6>
                        <p class="terms_list_item">
                            1. Użytkownik ma prawo zaprzestać korzystania ze
                            swojego Konta i dostępnych Usług Platformy, jak
                            również żądać jego usunięcia. Żądanie zgłasza do
                            obsługi administracyjnej Novakid.
                        </p>
                        <p class="terms_list_item">
                            2. Użytkownik będący konsumentem w rozumieniu
                            przepisów Kodeksu cywilnego ma prawo odstąpienia od
                            Umowy bez podania przyczyny w terminie 14 dni od
                            daty jej zawarcia.
                        </p>
                        <p class="terms_list_item">
                            3. W celu skorzystania z prawa odstąpienia od Umowy
                            Użytkownik powinien, w terminie 14 dni od dnia jej
                            zawarcia, przesłać formularz oświadczenia o
                            odstąpieniu na adres e‐mail: bok@novakid.pl.
                            Użytkownik może skorzystać ze wzoru formularza
                            oświadczenia o odstąpieniu umieszczonego na Stronie.
                        </p>
                        <p class="terms_list_item">
                            4. Prawo do odstąpienia od Umowy nie przysługuje w
                            sytuacji, gdy spełnianie świadczenia rozpoczęło się
                            za wyraźną zgodą Użytkownika przed upływem terminu
                            do odstąpienia od Umowy i po poinformowaniu go o
                            utracie prawa odstąpienia od Umowy, jak również po
                            wykonaniu całości Umowy.
                        </p>
                        <p class="terms_list_item">
                            5. Wzór odstąpienia od Umowy stanowi Załącznik nr 1
                            do Regulaminu. Skorzystanie ze wzoru nie jest
                            konieczne do prawidłowego odstąpienia od Umowy.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §18
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ROZWIĄZANIE UMOWY
                        </h6>
                        <p class="terms_list_item">
                            1. Umowa może zostać przez Użytkownika rozwiązana
                            poprzez złożenie odpowiedniego oświadczenia
                            skierowanego do Novakid poprzez wiadomość e-mail.
                        </p>
                        <p class="terms_list_item">
                            2. W sytuacji opisanej w ust. 1 Użytkownikowi nie
                            przysługuje zwrot środków pieniężnych z tytułu
                            niewykorzystanych lekcji w ramach zakupionego
                            Pakietu lekcji lub Subskrypcji.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §19
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            ROZWIĄZYWANIE SPORÓW
                        </h6>
                        <p class="terms_list_item">
                            1. Użytkownik ma prawo skorzystania z pozasądowych
                            sposobów rozpatrywania reklamacji i dochodzenia
                            roszczeń, tj.:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) zwrócenie się do wojewódzkiego inspektora
                                Inspekcji Handlowej z wnioskiem o wszczęcie
                                postępowania mediacyjnego w sprawie polubownego
                                zakończenia sporu. Informacje dotyczące
                                procedury mediacyjnej znajdują się w siedzibach
                                oraz na stronach internetowych poszczególnych
                                Wojewódzkich Inspektoratów Inspekcji Handlowej;
                            </p>
                            <p class="terms_list_item">
                                b) zwrócenie się do stałego polubownego sądu
                                konsumenckiego działającego przy wojewódzkim
                                inspektorze Inspekcji Handlowej z wnioskiem o
                                rozstrzygnięcie sporu wynikłego z zawartej
                                umowy. Wykaz stałych polubownych sądów
                                konsumenckich znajduje się na stronie
                                internetowej Urzędu Ochrony Konkurencji i
                                Konsumentów: www.uokik.gov.pl/wazne_adresy.php ;
                            </p>
                            <p class="terms_list_item">
                                c) zwrócenie się o bezpłatną pomoc prawną do
                                miejskiego (powiatowego) rzecznika konsumentów
                                lub organizacji społecznej, do której zadań
                                statutowych należy ochrona konsumentów, m.in.
                                Federacji Konsumentów (
                                www.federacja‐konsumentow.org.pl ). Szczegółowe
                                informacje o pozasądowych sposobach
                                rozpatrywania reklamacji i dochodzenia roszczeń,
                                a także zasady dostępu do tych procedur dostępne
                                są w siedzibach oraz na stronach internetowych
                                powiatowych (miejskich) rzeczników konsumentów,
                                organizacji społecznych, do których zadań
                                statutowych należy ochrona konsumentów,
                                Wojewódzkich Inspektoratów Inspekcji Handlowej
                                oraz Urzędu Ochrony Konkurencji i Konsumentów.
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            2. Skorzystanie z pozasądowych sposobów
                            rozpatrywania reklamacji i dochodzenia roszczeń ma
                            charakter dobrowolny i może mieć miejsce, gdy obie
                            strony sporu wyrażą na to zgodę.
                        </p>
                        <p class="terms_list_item">
                            3. Jeżeli strony nie osiągną porozumienia
                            polubownie, właściwym dla rozstrzygania wszelkich
                            sporów będzie sąd powszechny w Polsce.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §20
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            PRAWA AUTORSKIE
                        </h6>
                        <p class="terms_list_item">
                            1. Novakid przysługuje całość praw autorskich
                            majątkowych do utworów znajdujących się na
                            Platformie, w tym m.in. do materiałów edukacyjnych.
                        </p>
                        <p class="terms_list_item">
                            2. Wszelkie kopiowanie, dystrybucja i inny użytek
                            Treści zawartych na Platformie bez uprzedniej
                            pisemnej zgody Novakid jest zabroniony.
                        </p>
                        <p class="terms_list_item">
                            3. Użytkownik nie ma prawa korzystać handlowo,
                            sprzedawać, odsprzedawać lub w jakikolwiek inny
                            sposób przekazywać, kopiować, dystrybuować ani
                            promować Treści na Platformie. Użytkownik nie będzie
                            mieć także prawa do użycia Treści w sposób, który
                            wymaga uzyskania licencji na użytek (odtwarzanie)
                            publiczny.
                        </p>
                    </div>
                    <div class="offset-top-60">
                        <h6 class="terms_list_title text-bold text-center">
                            §21
                        </h6>
                        <h6 class="terms_list_title text-bold text-center">
                            POSTANOWIENIA KOŃCOWE
                        </h6>
                        <p class="terms_list_item">
                            1. Możliwe są zmiany niniejszego Regulaminu. W takim
                            wypadku każdy z Użytkowników powinien otrzymać
                            informację o zaistniałej zmianie poprzez
                            korespondencję e‐ mail lub poprzez komunikat na
                            Stronie lub Platformie, w obu przypadkach, z co
                            najmniej 14‐dniowym wyprzedzeniem. Zmiany wchodzą w
                            życie w dacie wskazanej w informacji, o której mowa
                            w niniejszym ustępie.
                        </p>
                        <p class="terms_list_item">
                            2. Novakid zastrzega sobie prawo do zmiany
                            niniejszego Regulaminu z niżej wskazanych przyczyn:
                        </p>
                        <ul>
                            <p class="terms_list_item">
                                a) zmiany przepisów powszechnie obowiązującego
                                prawa – odpowiednio w tym koniecznym zakresie;
                            </p>
                            <p class="terms_list_item">
                                b) realizacji obowiązku wynikającego z
                                prawomocnego orzeczenia sądu lub decyzji organów
                                administracji;
                            </p>
                            <p class="terms_list_item">
                                c) zmian wynikających ze względów
                                bezpieczeństwa, w tym mających na celu
                                uniemożliwienie korzystania z Platformy, w
                                sposób sprzeczny z przepisami prawa lub z
                                niniejszym Regulaminem;
                            </p>
                            <p class="terms_list_item">
                                d) wprowadzenia istotnych zmian w funkcjonowaniu
                                Platformy, w tym związanych z postępem
                                technicznym lub technologicznym, obejmujących
                                zmiany w systemach Novakid.
                            </p>
                        </ul>
                        <p class="terms_list_item">
                            3. Użytkownikowi, który nie akceptuje wprowadzonych
                            w Regulaminie zmian, przysługuje uprawnienie do
                            rozwiązania umowy o świadczenie Usług drogą
                            elektroniczną.
                        </p>
                        <p class="terms_list_item">
                            4. Regulamin oraz umowy o świadczenie Usług
                            podlegają prawu polskiemu. W sprawach
                            nieuregulowanych w Regulaminie zastosowanie mają
                            przepisy ustawy o świadczeniu usług drogą
                            elektroniczną, ustawy o prawach konsumenta, ustawy o
                            ochronie danych osobowych, Rozporządzenia Parlamentu
                            Europejskiego i Rady (UE) 2016/79 z dnia 27 kwietnia
                            2016 r. w sprawie ochrony osób fizycznych w związku
                            z przetwarzaniem danych osobowych i w sprawie
                            swobodnego przepływu takich danych oraz uchylenia
                            dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie
                            danych), Kodeksu cywilnego i inne bezwzględnie
                            obowiązujące przepisy prawa.
                        </p>
                        <p class="terms_list_item">
                            5. Załączniki do Regulaminu stanowią integralną jego
                            część.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {}
</script>
